import { render, staticRenderFns } from "./GeneralFarmConsultActions.vue?vue&type=template&id=bd7995a0&"
import script from "./GeneralFarmConsultActions.vue?vue&type=script&lang=js&"
export * from "./GeneralFarmConsultActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports